document.addEventListener('DOMContentLoaded',function(){
  const closeButton=document.querySelector('.close-top-bar');
  const closeButton2=document.querySelector('.close-bar');
  const topBar=document.querySelector('.top-announcement-bar');
  const announcementBar=document.querySelector('.announcement2');
  let sliderStarted=false;

  if(document.documentElement.classList.contains('bar-closed')){
    return;
  }
  if(announcementBar&&closeButton2){
    closeButton2.addEventListener('click',function(){
      announcementBar.style.display='none';
      window.sessionStorage.setItem('BarClosed','true');
      document.documentElement.classList.add('bar-closed');
    });
  }
  if(document.documentElement.classList.contains('top-bar-closed')){
    announcementBar&&announcementBar.classList.remove('hidden');
    startSliderIfMobile();
    return;
  }
  if(topBar&&closeButton){
    closeButton.addEventListener('click',function(){
      topBar.style.display='none';
      announcementBar&&announcementBar.classList.remove('hidden');
      window.sessionStorage.setItem('topBarClosed','true');
      document.documentElement.classList.add('top-bar-closed');
      startSliderIfMobile();
    });
  } else {
    announcementBar&&announcementBar.classList.remove('hidden');
    startSliderIfMobile();
  }
  function startSliderIfMobile(){
    if(!sliderStarted&&window.innerWidth<768){
      sliderStarted=true;
      setupMobileSlider();
    }
  }
  function setupMobileSlider(){
    const rotator=document.querySelector('.announcement2-rotator');
    if(!rotator)return;
    const container=rotator.querySelector('.container');
    if(!container)return;
    const count=parseInt(container.dataset.count,10)||0;
    if(count<=1)return;
    const blocks=[];
    for(let i=0;i<count;i++){
      const col=container.querySelector(`.announcement__col--${i}`);
      if(col)blocks.push(col);
    }
    if(blocks.length<2)return;
    const fadeDuration=150;
    const visibleDuration=4500;
    const blockDuration=fadeDuration*2+visibleDuration;
    const totalDuration=count*blockDuration;
    let startTime=null;
    function getTransformOpacity(localTime){
      if(localTime<0)return{xPercent:100,opacity:0};
      if(localTime>blockDuration)return{xPercent:-100,opacity:0};
      if(localTime<fadeDuration){
        const frac=localTime/fadeDuration;
        return{xPercent:-100+frac*100,opacity:frac};
      } else if(localTime<fadeDuration+visibleDuration){
        return{xPercent:0,opacity:1};
      } else {
        const fadeOutStart=fadeDuration+visibleDuration;
        const frac=(localTime-fadeOutStart)/fadeDuration;
        return{xPercent:-frac*100,opacity:1-frac};
      }
    }
    function animate(timestamp){
      if(!startTime)startTime=timestamp;
      const elapsed=timestamp-startTime;
      const cycleTime=elapsed%totalDuration;
      blocks.forEach((block,i)=>{
        const blockStart=i*blockDuration;
        let localTime=cycleTime-blockStart;
        if(localTime<0)localTime+=totalDuration;
        const{ xPercent,opacity}=getTransformOpacity(localTime);
        block.style.transform=`translate(-50%,-50%) translateX(${xPercent}%)`;
        block.style.opacity=opacity;
        block.style.pointerEvents=opacity>0.5?'auto':'none';
      });
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  }
});